module.exports = __webpack_public_path__ + "img/hic-endocrine-nutritional-metabolic-diseases-female.800d9c18.png";